<template>

<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.87984 13.4721C2.03984 13.4721 2.07184 13.4561 2.21584 13.4241L5.09584 12.8481C5.39984 12.7681 5.70384 12.6241 5.94384 12.3841L12.9198 5.40809C13.9918 4.33609 13.9918 2.49609 12.9198 1.42409L12.3278 0.800094C11.2558 -0.271906 9.39984 -0.271906 8.32784 0.800094L1.35184 7.79209C1.12784 8.01609 0.96784 8.33609 0.88784 8.64009L0.27984 11.5521C0.19984 12.0961 0.35984 12.6241 0.74384 13.0081C1.04784 13.3121 1.49584 13.4721 1.87984 13.4721ZM2.42384 8.94409L9.39984 1.95209C9.86384 1.48809 10.7118 1.48809 11.1598 1.95209L11.7678 2.56009C12.3118 3.10409 12.3118 3.87209 11.7678 4.40009L4.80784 11.3921L1.84784 11.8881L2.42384 8.94409Z" fill="white"/>
<path d="M12.8558 14.4641H1.04779C0.583785 14.4641 0.279785 14.7681 0.279785 15.2321C0.279785 15.6961 0.663785 16.0001 1.04779 16.0001H12.7918C13.2558 16.0001 13.6398 15.6961 13.6398 15.2321C13.6238 14.7681 13.2398 14.4641 12.8558 14.4641Z" fill="white"/>
</svg>

</template>
<script>
export default {
  name: "EditIcon",
};
</script>